<template>
  <template v-if="props.rank === Ranks.Entry || props.rank === Ranks.Junior">
    <UButton
      v-if="props.rank === Ranks.Entry"
      color="neutral"
      variant="soft"
      class="capitalize text-base"
      size="md"
      icon="i-heroicons-key-20-solid"
      @click="emit('click', Ranks.Entry)"
    >
      {{ rank }}
    </UButton>
    <UButton
      v-else-if="props.rank === Ranks.Junior"
      color="info"
      variant="soft"
      class="capitalize text-base"
      size="md"
      icon="i-heroicons-key-20-solid"
      @click="emit('click', Ranks.Junior)"
    >
      {{ rank }}
    </UButton>
  </template>
  <UTooltip v-else :text="messageTooltip">
    <UButton
      v-if="props.rank === Ranks.Middle"
      color="warning"
      variant="soft"
      class="capitalize text-base"
      size="md"
      :icon="icon"
      @click="emit('click', Ranks.Middle)"
    >
      {{ rank }}
    </UButton>
    <UButton
      v-else-if="props.rank === Ranks.Senior"
      color="error"
      variant="soft"
      class="capitalize text-base"
      size="md"
      :icon="icon"
      @click="emit('click', Ranks.Senior)"
    >
      {{ rank }}
    </UButton>
    <UButton
      v-else
      color="secondary"
      variant="soft"
      class="capitalize text-base"
      size="md"
      :icon="icon"
      @click="emit('click', Ranks.Expert)"
    >
      {{ rank }}
    </UButton>
  </UTooltip>
</template>

<script lang="ts" setup>
import Ranks from "@/constants/ranks";
import { useUserStore } from "~/store";

const emit = defineEmits(["click"]);

const userStore = useUserStore();

const icon = computed(() =>
  userStore.isUpgraded ? "i-heroicons-key-20-solid" : "i-heroicons-lock-closed-20-solid"
);

const messageTooltip = computed(() => {
  if (!userStore.isLogged) {
    return "Bạn cần đăng nhập để mở khoá";
  } else if (!userStore.isUpgraded) {
    return "Bạn cần nâng cấp để mở khoá";
  } else {
    return "Đã mở khoá";
  }
});

const props = defineProps({
  rank: {
    type: String,
    validator(value) {
      return Object.values(Ranks).includes(value as string);
    },
    default: "entry",
  },
});
</script>
